/*
 * MDB shim for MDBRow
 * Files currently importing this symbol from "mdbreact":
 * - src/App.jsx
 * - src/Components/Custom/InformationChangeModal.jsx
 * - src/Components/Pipeline/ColumnPipeline.jsx
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Patient/pqQuoteSelector.jsx
 * - src/Seating/PresidentsClub/presidentsClubView.jsx
 * - src/Seating/PurchaseQueue/PODeliveryUpdate.jsx
 * - src/Seating/PurchaseQueue/ShippingDetailsReport.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Tasks/Tasks.jsx
 */

import MUIBox from "@mui/material/Box";

export default function MDBRow({ children, className, style, ...rest }) {
  return (
    <MUIBox
      className={className}
      style={{ display: "flex", flexWrap: "wrap", ...style }}
      {...rest}
    >
      {children}
    </MUIBox>
  );
}
